import { render, staticRenderFns } from "./CurrencyConfig.vue?vue&type=template&id=442e3d57&scoped=true&"
import script from "./CurrencyConfig.vue?vue&type=script&lang=js&"
export * from "./CurrencyConfig.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyConfig.vue?vue&type=style&index=0&id=442e3d57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e3d57",
  null
  
)

/* custom blocks */
import block0 from "./CurrencyConfig.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VIcon,VRow,VTooltip})
